// Validations Module Mutation Types
export const SET_VALIDATION_LOADING = "SET_VALIDATION_LOADING";
export const SET_VALIDATION_ERROR = "SET_VALIDATION_ERROR";
export const SET_VALIDATION_SUCCESS = "SET_VALIDATION_SUCCESS";
